module.exports = __webpack_public_path__ + "img/kiko.32860249.jpg";